import { etherscanBaseURL } from './config';

export const getEtherscanLink = tx => `${etherscanBaseURL}/tx/${tx && tx.hash ? tx.hash : tx}`;

export const buildSharingMessageSubject = isMyToken =>
  `Check out ${isMyToken ? 'my awesome new' : 'this awesome'} #EulerBeats!`;

export const buildSharingMessageBody = (isMyToken, url) => {
  return `${
    isMyToken ? 'I just bought my very own' : 'Check out this awesome'
  } #EulerBeats! An art+music generated #NFT.

  Check out my #art + #beat here:
  ${url}

  If there aren't any originals left, you can buy a print!
  Join the party and get involved at eulerbeats.com!

   #ethereum  #onchain #Euler`;
};
